import { Box, Container, Grid, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react'
import { fontLink, useMobile } from '../../../base';
import LangLink from '../../../Localization/LangLink';
import { Txt, useTxt } from '../../../Routes/Localized';
import { getNormalizedBrand } from '../../../Pages/Public/CarsPage/base';
import { FOOTER_COLOR } from './base';

function splitIntoChunks(array, chunkSize) {
    const result = [];

    for (let i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }

    return result;
}

export default function FooterCars() {
    const [initBrands, setInitBrands] = useState([]);
    const mobile = useMobile();
    const txt = useTxt();

    useEffect(() => {
        const randomBrands = txt(`default:799014`).split(',').sort(() => 0.5 - Math.random());
        setInitBrands(randomBrands);
    }, []);

    const brands = splitIntoChunks(initBrands.slice(0, mobile ? 8 : 16), 4);


    return (
        <Box sx={{
            bgcolor: FOOTER_COLOR, pt: { xs: "50px", sm: "50px", md: "80px" },
            ...(mobile && { px: '16px' }),
        }}>
            <Container
                maxWidth="xl"
                sx={{
                    pb: { xs: "40px", sm: "40px", md: "20px" },
                    pr: "0px !important",
                    pl: { xs: '0px', sm: '0px', md: '0px', lg: '32px', xl: '32px' },
                }}
            >
                <Grid
                    container
                    columns={24}
                    sx={{ pl: "20px" }}
                >
                    {brands.map((brandsArr, i) => (
                        <Grid
                            key={"FOOCGridItem" + i}
                            xs={24}
                            sm={12}
                            md={6}
                            lg={6}
                            item
                            sx={{ pt: { xs: "60px", sm: "60px", md: "30px" }, }}
                        >
                            <Box sx={{ display: "flex", flexDirection: "column" }}>
                                {brandsArr.map((brandName, j) => (
                                    <Box
                                        key={"FOOCars" + j}
                                        sx={{ display: "flex", flexDirection: "row", mb: "14px" }}
                                    >
                                        <Box
                                            component={LangLink}
                                            to={`cars/${getNormalizedBrand(brandName)}`}
                                            sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                alignItems: "center",
                                                alignContent: "center",
                                                width: "100%",
                                                mr: { xs: "33px", sm: "60px" },
                                                textDecoration: "none",
                                            }}

                                        >

                                            <Typography
                                                sx={{
                                                    textAlign: "left",
                                                    fontWeight: 400,
                                                    ...fontLink,
                                                    color: '#fff',
                                                    "&:hover": {
                                                        color: "white",
                                                    },
                                                    width: "fit-content",

                                                }}
                                            >
                                                <Txt value={brandName} id={`799000`} color='white' />
                                            </Typography>

                                        </Box>
                                    </Box>
                                ))}
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}
